import { Action, IOWidget, mk_widget, Pair, AsyncState } from 'widgets-for-react'
import { Map } from 'immutable'
import React from 'react'

import { ImageContainer } from './ImageContainer.gen'
import { link, getClassName } from '../utils.gen'
import { Link, Id, CMSState, ImageSize } from '../types.gen'

export type QuoteBlockProps<extra_images> = {
  text: string
  author?: string
  link?: Link | null
  image?: Id
  image_alt?: string
  size?: ImageSize<extra_images>
  get_default_data_src: () => ImageSize<extra_images>
  get_default_data_srcset: () => Pair<ImageSize<extra_images>, string>[]

  show_in_page_navigation: boolean
  navigation_title: string
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
  text_classname: string
  quote_classname: string
  visual_classname: string
  image_classname: string
  author_classname: string
  clickable_classname: string
}>

export function QuoteBlock<customBlockData, extra_images>(
  props: QuoteBlockProps<extra_images>,
  options?: { style?: QuoteBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, never>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => (
        <section
          id={props.navigation_title}
          className={getClassName(options, 'block_classname', '')}
          key={options && options.key ? options.key : 'quote-block' + Math.random()}
        >
          <div className={getClassName(options, 'inner_classname', '')}>
            <div className={getClassName(options, 'content_classname', '')}>
              <figure className={getClassName(options, 'text_classname', '')}>
                <blockquote>
                  <p className={getClassName(options, 'quote_classname', '')}>{props.text}</p>
                </blockquote>
                <div className={getClassName(options, 'visual_classname', '')}>
                  {cmsState.images.has(props.image) &&
                    ImageContainer(
                      cmsState.images.get(props.image) as AsyncState<Map<ImageSize<extra_images>, string>>,
                      props.size,
                      getClassName(options, 'image_classname', 'w-100'),
                      props.image_alt,
                      props.get_default_data_src,
                      props.get_default_data_srcset
                    ).run(_ => { })}
                </div>
                {props.author && (
                  <figcaption className={getClassName(options, 'author_classname', '')}>{props.author}</figcaption>
                )}
              </figure>
            </div>

            {props.link && (
              <footer>
                {props.link
                  ? link(props.link, { classname: getClassName(options, 'clickable_classname', '') }, props.link.title)
                  : null}
              </footer>
            )}
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/cms/blocks/widgets/quoteBlock.gen.tsx